module.exports = __webpack_public_path__ + "img/jupiter.3c0f458c.svg";